import Game from 'app/records/game'
import React, { PropTypes } from 'react'
import Strings from 'config/strings'
import TeamGif from '../team-gif'
import { padLeft } from 'lib/strings'

export default React.createClass({

  propTypes: {
    game : PropTypes.instanceOf(Game).isRequired
  },

  render() {
    const { game } = this.props

    const slot    = Game.getSlot(game)
    const current = Game.getCurrentTeam(game)

    return (
      <main className={ "statistics fill-team-" + slot }>
        <div className="container">

          <div className="turn-in-progress__card">
            <h2 className="turn-in-progress__title">Team { current.name }</h2>

            <TeamGif team={ current } short />

            <div className={ "turn-in-progress__rule " + "color-team-" + slot }>
              Round { game.round } • { Strings[`round.desc.${game.round }`] }
            </div>

            <p className="statistics__time">
              00:{ padLeft(game.time_remaining || 0, 2, '0') }
            </p>

            <div className="row">
              <div className="col round-starting__team no-vs fill-blue">
                { game.team_1.name }<br/>
                { game.team_1.score }
              </div>
              <div className="col round-starting__team fill-red">
                { game.team_2.name }<br/>
                { game.team_2.score }
              </div>
            </div>
          </div>
        </div>
      </main>
    )
  }

})



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/phases/statistics.jsx
 **/